import { NgModule } from '@angular/core';
import { ListItemComponent } from './list-item.component';



export class ListItemModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [ListItemComponent],
  exports: [ListItemComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
